export default __webpack_public_path__ + "static/mackenzie-investments-ba3acd45477789ffe02cb61a4f307dd8.svg";